I18n.translations.EN = {
	loading: 'loading...',
	developed_by: 'developed by',
	back: 'Back',
	yes: 'Yes',
	no: 'No',
	ok: 'OK',
	connection_error: 'Problem with connection',
	connection_down: 'An error has occurred related to your Internet connection.',
	connection_up: 'Internet connection has been restored.',
	error: 'Error:',
	timeout: 'Request timeout',
	player_error: 'Error with playing',
	err_config_fetch: 'Unable to load the API config.',
	err_throbber_timeout: 'Something is taking way too long, try again after a few minutes.',
	playback_error_message: 'An error has occurred related to video playback',
	please_sign_in: 'Please enter your account to sign in',
	enter_your_email: 'Enter your e-mail address',
	enter_your_password: 'Enter your password',
	email: 'E-MAIL',
	password: 'password',
	continue: 'Continue',
	skip_this_step: 'Skip this step',
	not_registred_yet: 'Not registered yet?',
	please_go_to: 'Please go to',
	lets_watch: 'Let\'s watch',
	invalid_credentials: 'Invalid credentials.',
	invalid_email: 'Please enter valid email.',
	invalid_password: 'Please enter valid password.',
	full_description: 'Full description',
	close_description: 'Close description',
	go_back: 'Go back',
	sign_in: "Sign In",
    sign_out: "Sign Out",
	min: 'min',
	no_Url: 'No Url',
	err_data_fetch: 'Data fetching or parsing failed',
	dialog_exit_title: 'Exit',
	dialog_exit_content: 'Would you like to exit the app?',
	token_expired:"Your login session has expired, please sign in.",
    issue_login:"If you're experiencing issues while using this app, please contact from 9AM to 6PM by email to: subscribers@allflamenco.net.",
	search: "Search by title, actor, director or author",
	search_title: "Search",
    results: 'Results for: "',
	go_back_catalog: 'Back to catalog',
	my_account: 'MY ACCOUNT',
	login_title: 'Log In Through Your Web Browser',
	login_line1: 'On your smartphone or PC, go to ',
	login_line2: 'Log in or register in ALL FLAMENCO',
	login_line3: 'Enter the following code',
	name: 'NAME',
	session: 'SESSION',
	subscription: 'Subscription',
	no_subscription: 'You\'re currently NOT SUBSCRIBED to ALL FLAMENCO',
	spacebar: 'Spacebar',
	play: 'Play',
	add_favorites: 'Add to favorites',
	remove_favorites: 'Remove from favorites',
	favorites: 'Favorites',
	continue_watching: 'Continue watching',
	requires_subscription: 'This title is not included in your current plan. You must first purchase it by going to app.allflamenco.net on any browser.	You will then be able to watch it here.',
	detail_ARTISTS: 'ARTISTS',
	detail_YEAR: 'PRODUCTION YEAR',
	detail_RATING: 'RATING',
	detail_STYLE: 'MUSIC STYLE',
	detail_GENRE: 'GENRE',
	detail_LANGUAGE: 'LANGUAGE',
	detail_LOC_CITY: 'LOCATION CITY',
	detail_LOC_PLACE: 'LOCATION PLACE',
	detail_TYPE: 'TYPE',
	detail_SEASON: 'SEASON',
	detail_EPISODE: 'EPISODE',
	detail_SERIES: 'Series', 
	detail_DURATION: 'DURATION',
	detail_DESCRIPTION: 'DESCRIPTION',
	purchases: 'PURCHASES',
	sub_active: 'Active subscription',
	sub_inactive: 'You currently don\'t have an active subsciption, please refer to app.allflamenco.net'
};


//////////////////
// WEBPACK FOOTER
// ./js/i18n/en.js
// module id = 41
// module chunks = 0